const ISRC_PATTERN = /^[A-Z]{2}[A-Z0-9]{3}[0-9]{7}$/;

/**
 * The ISRC as the server stores it (music24-api `normalizeIsrc`): no dashes and no spaces, upper
 * case, 12 characters. Null when the text is not an ISRC.
 */
export function normalizeIsrc(input: string): string | null {
  const value = input.replace(/[-\s]/g, '').toUpperCase();
  return ISRC_PATTERN.test(value) ? value : null;
}
